export default __webpack_public_path__ + "static/media/abshar2.04ac1535.jpg";